.input {
  border-width: 2px;
  border-color: var(--color-gray-200);
  border-radius: 4px;
  padding: 0.3rem 0.5rem;
}

/*.inputSuccess {*/
/*    background: url("../icons/tick-01-stroke-rounded.svg");*/
/*    background-size: 1.5rem;*/
/*    background-repeat: no-repeat;*/
/*    background-position: 95% 50%;*/
/*    border-color: #13FF75;*/
/*}*/

.inputFailure {
  background: url("../icons/alert-02-stroke-rounded.svg");
  background-size: 1.5rem;
  background-repeat: no-repeat;
  background-position: 95% 50%;
  border-color: #ff0315;
}

.edit {
  border-style: solid;
}

.formLabel {
  font-family: OpenSans, sans-serif;
  font-size: 16px;
  font-weight: 600;
  padding: 0.3rem;
  white-space: nowrap;
}
